module.exports = __webpack_public_path__ + "img/ommax-london-why.a680842a.jpg";